import React from 'react';
import { get } from 'lodash';
import useSWR from 'swr';
import { Grid, Skeleton } from '@mui/material';
import { Offers } from 'components';
import api from 'utils/api';
import { useLocation } from 'utils/location';
import { useSearchParams } from 'react-router-dom';
import useOfferDisplayMode from 'components/offers/useOfferDisplayMode';

const POPULAR_OFFERS_COUNT = 8;

const TopOffers = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  // Use radius from URL params, default to 100 miles for popular offers filtering
  const radiusParam = searchParams.get('radius');
  const radius = radiusParam ? parseFloat(radiusParam) : 100;
  const url = location
    ? `/offer/popular?latitude=${get(location, 'latitude')}&longitude=${get(location, 'longitude')}&radius=${radius}` +
      `&zipcode=${encodeURIComponent(get(location, 'zip') || '')}` +
      `&stateShortName=${encodeURIComponent(get(location, 'region_code') || '')}` +
      `&rows=${POPULAR_OFFERS_COUNT}`
    : null;
  
  const { data: offers } = useSWR(url, () => api.get(url), { revalidateOnFocus: false });
  
  // Get display mode from URL params
  const [displayMode] = useOfferDisplayMode(searchParams.get('display'));

  if (!offers) {
    return (
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="stretch"
      >
        {[...Array(POPULAR_OFFERS_COUNT)].map((_, index) => (
          <Grid key={index} item xs sx={{ display: 'flex', flexDirection: 'column' }}>
            <Skeleton
              variant="rectangular"
              height={150}
              sx={{ mb: 1 }}
            />
            {[...Array(4)].map((_, i) => (
              <Skeleton key={i} height={20} sx={{ mb: 0.5 }} />
            ))}
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Offers 
      offers={offers || []} 
      offerOrigin="topOffers" 
      offerType={displayMode}
      columns={3}
    />
  );
};

export default TopOffers;
